import type { EnumUIItem } from '@/enumUI/EnumUIItem'
import { PersonRole } from '../enums/PersonRole'

export const PersonRoleUI: Record<PersonRole, EnumUIItem> = {
  [PersonRole.FutureStudent]: { label: 'Будущий ученик' },
  [PersonRole.ParentOfFutureStudent]: { label: 'Родитель будущего ученика' },
  [PersonRole.Child]: {
    label: 'Ребёнок',
  },
  [PersonRole.Student]: {
    label: 'Ученик',
  },
  [PersonRole.Teacher]: {
    label: 'Преподаватель',
  },
  [PersonRole.ExStudent]: {
    label: 'Бывший ученик',
  },
  [PersonRole.SmartStudent]: {
    label: 'Smart-ученик',
  },
  [PersonRole.SmartExStudent]: {
    label: 'Бывший Smart-ученик',
  },
  [PersonRole.AdmissionApplicant]: {
    label: 'Абитуриент',
  },
  [PersonRole.ExAdmissionApplicant]: {
    label: 'Бывший абитуриент',
  },
  [PersonRole.Parent]: {
    label: 'Родитель',
  },
  [PersonRole.ParentOfStudent]: {
    label: 'Родитель ученика',
  },
  [PersonRole.ParentOfExStudent]: {
    label: 'Родитель бывшего ученика',
  },
  [PersonRole.ParentOfSmartStudent]: {
    label: 'Родитель smart-ученика',
  },
  [PersonRole.ParentOfSmartExStudent]: {
    label: 'Родитель бывшего smart-ученика',
  },
  [PersonRole.ParentOfAdmissionApplicant]: {
    label: 'Родитель абитуриента',
  },
  [PersonRole.ParentOfExAdmissionApplicant]: {
    label: 'Родитель бывшего абитуриента',
  },
  [PersonRole.Employee]: {
    label: 'Сотрудник',
  },
  [PersonRole.FamilyAssistant]: {
    label: 'Помощник',
  },
  [PersonRole.NoRole]: {
    label: 'Без роли',
  },
}
